import ClassNames from 'classnames'
import React from 'react'
import {
  ModalBase
} from './../../base'
import { ModalWrapper } from './styled'

export class Modal extends React.PureComponent {
  render() {
    const {
      children,
      className,
      scroll,
      second,
      fluid,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      { 'is-scroll': scroll },
      { 'is-second-modal': second },
      { 'is-fluid': fluid }
    )

    return (
      <ModalWrapper
        {...this.props}
        className={classes}
      >
        {children}
      </ModalWrapper>
    )
  }

  static Section = ModalBase.Section

  static defaultProps = {
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
